module.exports = __webpack_public_path__ + "static/media/ladbrokes-coral-logo-charcoal.03afc652.svg";